import React, { ChangeEvent } from 'react';

type RadioGroupContextType =
  | {
      name?: string;
      value?: string;
      onChange?: (value: string | undefined, e: ChangeEvent) => void;
    }
  | undefined;

const RadioGroupContext = React.createContext<RadioGroupContextType>(undefined);

export default RadioGroupContext;
